import { QuestionnaireQuestion } from "@repo/api";
import { useMemo } from "react";
import { QuestionnaireFormValues } from "./QuestionnairePage.helpers";

export const linkAnswersWithQuestions = (data: QuestionnaireQuestion[] | undefined) => {
    return (values: QuestionnaireFormValues) => {
        const findApiAnswer = (question: QuestionnaireQuestion | undefined, answerId: string) => {
            return question?.answers?.find((a) => a.id === answerId);
        };

        return Object.keys(values).map((questionId) => {
            const apiQuestion = data?.find((q) => q.id === questionId);

            let userAnswers: {
                [answerId: string]: boolean | string | null | undefined;
            } = {};
            if (values[questionId] && typeof values[questionId] === "object") {
                userAnswers = values[questionId];
            } else if (values[questionId] && typeof values[questionId] === "string") {
                userAnswers = { [values[questionId]]: true };
            }

            return {
                apiQuestion,
                questionId,
                userAnswers: Object.keys(userAnswers).map((answerId) => {
                    const apiAnswer = findApiAnswer(apiQuestion, answerId);
                    const answer = userAnswers[answerId];
                    return {
                        apiAnswer,
                        answerId,
                        answer,
                    };
                }),
            };
        });
    };
};

export const useLinkAnswersWithApiQuestions = (data: QuestionnaireQuestion[] | undefined) => {
    return useMemo(() => linkAnswersWithQuestions(data), [data]);
};
